import { VehicleImage } from '@porterin/booking-flow/src/order-review/domain/entities/VehicleResult';

export type ImageVM = VehicleImage;

export interface FormFieldVM {
  placeholder: string;
  leadingIcon?: ImageVM;
  trailingIcon?: ImageVM;
}

export interface EditLocationModalVM {
  changeText: string;
  headerText: string;
  ctaText: string;
  addressField: FormFieldVM;
  houseField: FormFieldVM;
  nameField: FormFieldVM;
  mobileField: FormFieldVM;
  fieldIcon?: ImageVM;
  closeIcon: ImageVM;
}

export interface GoodsTypeVM {
  text: string;
  defaultSelectText: string;
  changeText: string;
  beforeSelectCtaText: string;
  afterSelectCtaText: string;
  icon: ImageVM;
}

export interface EtaCapsuleVM {
  title: string;
  icon: ImageVM;
}

export interface FareBreakupTripFareVM {
  text: string;
  subText?: string;
}

export interface FareBreakupVM {
  title: string;
  tripFare: FareBreakupTripFareVM;
  netFare: string;
  amountPayable: string;
}

export interface PaymentMethodVM {
  text: string;
  subText: string;
  icon: ImageVM;
}

export interface PaymentFeatureVM {
  title: string;
  subtitle?: string;
  disclaimer?: string;
  icon: ImageVM;
}

export interface PaymentMethodModalVM {
  title: string;
  ctaText: string;
  cash: PaymentFeatureVM;
  porterWallet: PaymentFeatureVM;
}

export interface OrderReviewContentVM {
  addressDetailsText: string;
  editText: string;
  selectVehicleText: string;
  currencySymbol: string;
  unitText: string;
  doneCtaText: string;
  viewBreakupText: string;
  dropPinIcon: ImageVM;
  mobileHeader: { title: string; backIcon: ImageVM };
  goodsType: GoodsTypeVM;
  etaCapsule: EtaCapsuleVM;
  fareBreakup: FareBreakupVM;
  paymentMethod: PaymentMethodVM;
  paymentMethodModal: PaymentMethodModalVM;
  editPickupModal: EditLocationModalVM;
  editDropModal: EditLocationModalVM;
}

export const EMPTY_IMAGE: ImageVM = { path: '', altText: '' };
